import React from "react";
import { cmsUrl } from "../../utils/CmsUtils";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import Icon from "../Icon";
import CockpitEditLink from "../CockpitEditLink";
import { ProductDocument } from "../../types/ProductDocument";

const ProductDocuments = ({ documents }: { documents: ProductDocument[] }) => {
  const t = useBjelinTranslations();
  if (Array.isArray(documents) && documents.length > 0) {
    const documentItems = documents.map((document, idx) => {
      const url = cmsUrl(
        document.file ? "/" + document.file : "/storage" + document.url
      );
      const text = document.category
        ? t(`document.${document.category}`)
        : document.name;
      const icon = <Icon name="download" />;
      return (
        <li key={idx}>
          <a
            href={url}
            className={"document"}
            target={"_blank"}
            rel="noopener noreferrer"
          >
            {icon} {text}
          </a>
          <CockpitEditLink
            collection={"documents"}
            _id={document._id}
            wrapper={children => children}
          />
        </li>
      );
    });
    return <ul className="document-listing">{documentItems}</ul>;
  } else {
    return null;
  }
};

export default ProductDocuments;
